export default "__VITE_ASSET__DCwi0xCC__"